import styles from "../styles/productCard.module.css";

const ProductSkeleton = ({ count = 1 }) => {
  return (
    <div className={styles.grid}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={styles.card}>
          <div className={`${styles.skelMedia} skeleton`}></div>
          <div className={styles.body}>
            <span className={`${styles.skelTag} skeleton`}></span>
            <span className={`${styles.skelName} skeleton`}></span>
            <span className={`${styles.skelMeta} skeleton`}></span>
            <span className={`${styles.skelPrice} skeleton`}></span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProductSkeleton;
